import React, { useRef } from "react"
import "./style.scss";
import { Question, QuestionData } from "../../global-interfaces";
import { makeScaleLinear } from "../../utils"
import { scaleLinear, format, max, ScaleLinear } from "d3";
import Classnames from "classnames";

const pct_format: any = format(".0%");

interface Props {
  chart: Question;
  color: string | null;
}

export default function VerticalTwo( {chart, color } : Props) {
  
  /* APP STATE */
  const data = chart.data;
  const chartRef = useRef(null)

  /* TRANSFORMATIONS */
  /** custom scale so that if the values are all less than 25%, the domain is 0-50% instead of 0-100% */
  const scale = makeScaleLinear([0, (chart.scale === 1 ? max(data, d => d.value) : chart.scale) || 1])

  return (
    <div className={Classnames("VerticalTwo", color)} ref={chartRef}>
      <div className="bars-container">
        {data.map((d: QuestionData, i: number) => <div className={Classnames("bar-group", { 
          left: i === 0, 
          right: i === 1 
        })}> 
          <div className={Classnames("bar-label")} style={{ 
            height: pct_format(scale(d.value)) 
          }}>{d.label}</div>
          <Bar value={d.value} scale={scale} />
        </div>)}
      </div>
      {chart.category && <div className="category-label selected">{chart.category}</div>}
    </div>
  )

}

function Bar({ scale, value } : { scale: ScaleLinear<number, number>, value: number }) {
  return <div className="bar-measure" style={{ height: pct_format(scale(value)) }}>
    <span>{pct_format(value)}</span>
  </div>
}
